import React, { useRef, useState } from "react";
import { Volume2, Loader2 } from "lucide-react";
import { API } from "@/lib/api";

// Reproduce audio de pronunciación en alemán (TTS cacheado en el backend).
export default function AudioButton({ text, size = 16, label = "Escuchar pronunciación" }) {
  const audioRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [playing, setPlaying] = useState(false);

  const play = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      if (!audioRef.current) {
        audioRef.current = new Audio(`${API}/tts?text=${encodeURIComponent(text)}`);
        audioRef.current.onplaying = () => { setPlaying(true); setLoading(false); };
        audioRef.current.onended = () => setPlaying(false);
        audioRef.current.onerror = () => { setLoading(false); setPlaying(false); };
      }
      setLoading(true);
      audioRef.current.currentTime = 0;
      await audioRef.current.play();
    } catch {
      setLoading(false);
    }
  };

  return (
    <button onClick={play} aria-label={label} title={label} data-testid="audio-btn"
      className={`inline-flex items-center justify-center rounded-md p-1.5 transition-colors hover:bg-secondary text-accent ${playing ? "bg-accent/10" : ""}`}>
      {loading ? <Loader2 size={size} className="animate-spin" /> : <Volume2 size={size} />}
    </button>
  );
}
